import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { ModalDialog } from 'components/ModalDialog';
import type { PriceListUerRowData } from 'gql/graphql';

import cn from 'classnames';

import { useDataAgreementPriceListModal } from './useDataAgreementPriceListModal';

import Styles from './AgreementPriceListUerModal.module.css';

interface IAgreementPriceListModal {
    expandedRowData: PriceListUerRowData | null;
    onClose: () => void;
}

export const AgreementPriceListUerModal = ({ expandedRowData, onClose }: IAgreementPriceListModal) => {
    const { columns, rowData, title } = useDataAgreementPriceListModal(expandedRowData);

    const gridOptions = {
        headerHeight: 40,
    };

    return (
        <ModalDialog
            isOpen
            title={title}
            onClose={onClose}
            dockedToWindow="bottom"
            withTitleCloseButton
            isOnClickOutsideDisable
            withBottomButtons={false}
        >
            <div className={cn('ag-theme-alpine', Styles.wrapTable)}>
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columns}
                    animateRows
                    gridOptions={gridOptions}
                    suppressCellFocus
                    suppressRowHoverHighlight
                />
            </div>
        </ModalDialog>
    );
};

AgreementPriceListUerModal.displayName = 'AgreementPriceListUerModal';
